import { LoadingButton } from "@mui/lab";
import { Card, CardContent, Dialog, DialogTitle, DialogContent, Box, DialogActions, Button, Slide } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import placementChange from "../../../../assets/changePlacement.svg"
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks/hooks";
import dayjs, { Dayjs } from "dayjs";
import PlacementApi from "../../../../store/services/placement";
import { GetRequests, StudentActions } from "../../../../store/StudentAction";
import { useNavigate } from "react-router-dom";
import { TransitionProps } from "@mui/material/transitions";
import upload from "../../../../assets/upload.svg"
import AddHomeRoundedIcon from '@mui/icons-material/AddHomeRounded';
import { createNotifictions } from "../../../../utils/helperFunction";
import moment from "moment";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const PlacementChange = () => {
    const [open, setOpen] = React.useState(false);
    const userDetails = useAppSelector((state: any) => state.user.user)
    const placementDetails = useAppSelector((state:any) => state.user.placement)
    const [isLoading, setIsLoading] = useState(false)
    const [placementStart, setPlacementStart] = useState<Dayjs | null>(null)
    const [placementEnd, setPlacementEnd] = useState<Dayjs | null>(null)
    const [newJobRole, setNewJobRole] = useState("")
    const [newCompany, setNewCompany] = useState("")
    const [postCode, setPostCode] = useState("")
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const fetcRequests = async () => {
        await dispatch(GetRequests())
    }
    const handleSubmit = async (e: any) => {
        setIsLoading(true)
        e.preventDefault()
        let body = {
            requestCode: "CP",
            Placement_ID: userDetails.result.Placement_ID,
            Status: "0",
            details: {
                dateApplied: new Date(),
                newJobRole: newJobRole,
                newCompany: newCompany,
                postCode: postCode,
                newPlacementStart: placementStart && new Date(placementStart?.toString()),
                newPlacementEnd: placementEnd && new Date(placementEnd?.toString())
            }
        }
        PlacementApi.postNewRequest(body).then(res => {
            createNotifictions({
                target:placementDetails.PlacementAdmin,
                message:`New Placement Change request generated by ${userDetails.result.first_name} ${userDetails.result.last_name} `,
                type:"RQ"
            })
            fetcRequests()
            dispatch(StudentActions.setMessage("Placement Change Request Generated"))
            setIsLoading(false)
        }).catch((e) => {
            if (e.response.status === 403) {
                navigate('/login')
            }
            setIsLoading(false)
            reset()
            dispatch(StudentActions.setMessage("Request Generation Failed.Try again."))
        })
    }
    const reset = () => {
        setPlacementEnd(placementDetails.Placement_End)
        setPlacementStart(placementDetails.Placement_Start)
    }
    useEffect(() => {
        handleClose()
        setPlacementEnd(placementDetails.Placement_End)
        setPlacementStart(placementDetails.Placement_Start)
    },[isLoading])

    return (
        <div>
            <Card className='cardRequest' onClick={handleClickOpen}>
                <CardContent>
                    <div className='align-content-center align-items-center flex flex-column contentMob'>
                        <img src={placementChange} alt="placement Change Icon" className='cardImage'></img>
                        <p className='font-weight-700 m-0'>Placement Change</p>
                    </div>
                </CardContent>
            </Card>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                className='w-100'
                keepMounted
                fullWidth
                maxWidth="md"
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Placement Change Request</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit}>
                        <div className='gridContainer'>
                            <div className='flex flex-column'>
                                <div className='flex flex-column m-2'>
                                    <label className='required'>New Company</label>
                                    <input value={newCompany} onChange={(e) => {
                                        setNewCompany(e.target.value)
                                    }}></input>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <label className='required'>Job Role</label>
                                    <input value={newJobRole} onChange={(e) => {
                                        setNewJobRole(e.target.value)
                                    }}></input>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <label className='required'>PostCode</label>
                                    <input value={postCode} onChange={(e) => {
                                        setPostCode(e.target.value)
                                    }}></input>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <label className='required'>Placement Start</label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Placment Start"
                                            inputFormat="MM/DD/YYYY"
                                            value={placementStart}
                                            onChange={(e: any) => {
                                                setPlacementStart(e)
                                            }}
                                            renderInput={({ inputRef, inputProps, InputProps }) => (
                                                <Box sx={{ display: 'flex', alignItems: 'center', margin: '5px' }}>
                                                    <input ref={inputRef} {...inputProps} />
                                                    {InputProps?.endAdornment}
                                                </Box>
                                            )}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <label className='required'>Placement End</label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Placment End"
                                            inputFormat="MM/DD/YYYY"
                                            value={placementEnd}
                                            minDate={dayjs(placementStart)}
                                            onChange={(e: any) => {
                                                setPlacementEnd(e)
                                            }}
                                            renderInput={({ inputRef, inputProps, InputProps }) => (
                                                <Box sx={{ display: 'flex', alignItems: 'center', margin: '5px' }}>
                                                    <input ref={inputRef} {...inputProps} />
                                                    {InputProps?.endAdornment}
                                                </Box>
                                            )}
                                        />

                                    </LocalizationProvider>

                                </div>
                                <div className='flex flex-column m-2'>
                                    <label>Attachments</label>
                                    <div className='align-items-md-center flex flex-column justify-content-center m-2 p-2 attachContainer'>
                                        <img src={upload} alt="uploadImage" style={{
                                            height: "80px"
                                        }}></img>
                                        <p className='font-weight-700 m-0'>Upload a file</p>
                                        <p className='subTitle gray-color body-p m-0 '>PNG,JPG,GIF upto 10MB</p>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-column m-2'>
                                <label className='required'>Current Placement Details</label>
                                <Card className='mx-2 mt-2 detailsCard'>
                                    <CardContent>
                                        <div className='pt-2 px-2'>
                                            <p className='body-p gray-color m-0'>Your Placement details</p>
                                            <div className='p-3'>
                                                <div className='flex justify-content-between mb-2'>
                                                    <p className='body-p m-0'>Company Name:</p>
                                                    <p className='font-weight-700 m-0 text-Primary'>{placementDetails.CompanyName}</p>
                                                </div>
                                                <div className='flex justify-content-between mb-2'>
                                                    <p className='body-p m-0'>Role:</p>
                                                    <p className='font-weight-700 m-0 text-Primary'>{placementDetails.JobRoles}</p>
                                                </div>
                                                <div className='flex justify-content-between mb-2'>
                                                    <p className='body-p m-0'>Current Placement Start:</p>
                                                    <p className='font-weight-700 m-0 text-Primary'>{moment(placementDetails.Placement_Start).format('D/M/YYYY')}</p>
                                                </div>
                                                <div className='flex justify-content-between'>
                                                    <p className='body-p m-0'>Current Placement End:</p>
                                                    <p className='font-weight-700 m-0 text-Primary'>{moment(placementDetails.Placement_End).format('D/M/YYYY')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                            </div>
                        </div>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <LoadingButton
                        loading={isLoading}
                        loadingPosition="start"
                        onClick={handleSubmit}
                        startIcon={<AddHomeRoundedIcon />}
                        variant="contained"
                        disabled={placementStart === placementDetails.Placement_Start && placementEnd === placementDetails.Placement_End} autoFocus
                    >
                        Request Now
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    )

}
export default PlacementChange;